import { useEffect, useRef } from 'react';

interface HeroVideoProps {
  src: string;
  className?: string;
  preload?: 'auto' | 'metadata' | 'none';
}

/**
 * Muted background loop that autoplays on Android as well as iOS and desktop.
 * React only sets `muted` as a property, and some Android browsers read the
 * attribute before allowing autoplay, so both are set on mount, then play()
 * is asked for directly.
 */
export default function HeroVideo({ src, className, preload }: HeroVideoProps) {
  const ref = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.muted = true;
    el.defaultMuted = true;
    el.setAttribute('muted', '');
    el.setAttribute('playsinline', '');
    el.play().catch(() => {});
  }, [src]);

  return (
    <video ref={ref} src={src} className={className} autoPlay muted loop playsInline preload={preload} aria-hidden="true">
      <source src={src} type="video/mp4" />
    </video>
  );
}
